'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpMain = /** @class */function () {
    function HelpMain() {
        this.searchBoxDom = document.getElementById('search');
        this.currentPage = 1;
        this.total = 0;
        this.goodsCategoryId = 0;
        this.displayDom = document.getElementById('operate-goods');
        this.goodsListDom = _tool2.default.$_select(this.displayDom, '.help-product-item ul');
        this.init();
    }
    HelpMain.prototype.init = function () {
        this.handleSearch();
        this.handlePagination();
    };
    HelpMain.prototype.handleSearch = function () {
        var inputBox = _tool2.default.$_select(this.searchBoxDom, '.help-input-box');
        var inputImgBox = _tool2.default.$_select(this.searchBoxDom, '.input-img-box');
        var inputDom = _tool2.default.$_select(this.searchBoxDom, '.search-input');
        var inputIcon = _tool2.default.$_select(this.searchBoxDom, '.input-icon');
        var searchBtn = _tool2.default.$_select(this.searchBoxDom, '.search-btn');
        var cloneInputValueDom = _tool2.default.$_select(this.searchBoxDom, '.clone-input-value');
        var isSelectText = false;
        var timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                cloneInputValueDom.innerText = inputVal;
            } else {
                cloneInputValueDom.innerText = 'Please enter keywords to search';
            }
        }, 50);
        inputBox.addEventListener('click', function (e) {
            inputDom.focus();
            inputIcon.classList.add('hide');
            searchBtn.classList.add('show');
            inputDom.classList.add('add-width');
            inputImgBox.classList.add('add-width');
            cloneInputValueDom.classList.add('hide');
            var inputVal = inputDom.value.trim();
            if (inputVal == '') {
                cloneInputValueDom.innerText = '';
            }
            var target = e.target;
            if (inputVal != '') {
                searchBtn.classList.add('active');
            } else {
                searchBtn.classList.remove('active');
            }
            if (searchBtn.contains(target)) {
                if (inputVal != '') {
                    window.open("/searchResult?keywords=".concat(inputVal, "&tab=course&page=1"));
                } else {
                    alert('The content of the input box cannot be empty.');
                }
            }
            e.stopPropagation();
        });
        inputDom.addEventListener('keyup', function (event) {
            var e = event || window.event;
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                searchBtn.classList.add('active');
                if (e.keyCode === 13) {
                    window.open("/searchResult?keywords=".concat(inputVal, "&tab=course&page=1"));
                }
            } else {
                searchBtn.classList.remove('active');
                if (e.keyCode === 13) {
                    alert('The content of the input box cannot be empty.');
                }
            }
        });
        inputDom.addEventListener('select', function () {
            isSelectText = true;
        });
        document.addEventListener('click', function () {
            var timer;
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (!isSelectText) {
                    inputIcon.classList.remove('hide');
                    searchBtn.classList.remove('show');
                    inputDom.classList.remove('add-width');
                    inputImgBox.classList.remove('add-width');
                    cloneInputValueDom.classList.remove('hide');
                    var inputVal = inputDom.value.trim();
                    if (inputVal != '') {
                        cloneInputValueDom.innerText = inputVal;
                    } else {
                        cloneInputValueDom.innerText = 'Please enter keywords to search';
                    }
                }
                isSelectText = false; // 回到初始状态
            }, 50);
        });
    };
    HelpMain.prototype.handlePagination = function () {
        var that = this;
        var goodsCategoryLiDom = _tool2.default.$_selectAll(this.displayDom, '.help-product-category li');
        var paginationNumDom = _tool2.default.$_select(this.displayDom, '.pagination-page-num');
        var preBtn = _tool2.default.$_select(this.displayDom, '.pagination-page-pre');
        var nextBtn = _tool2.default.$_select(this.displayDom, '.pagination-page-next');
        this.handleAppend({
            unitSelector: '.pagination-page-num a',
            val: this.goodsCategoryId,
            parentDom: paginationNumDom
        });
        this.handleAppend({
            unitSelector: '.help-product-category li',
            val: this.goodsCategoryId,
            parentDom: this.goodsListDom
        });
        // 分类点击事件
        goodsCategoryLiDom.forEach(function (item) {
            item.addEventListener('click', function () {
                goodsCategoryLiDom.forEach(function (cItem) {
                    return cItem.classList.remove('active');
                });
                item.classList.add('active');
                if (that.goodsCategoryId != Number(item.getAttribute('data-id'))) {
                    that.goodsCategoryId = Number(item.getAttribute('data-id'));
                    that.handleAppend({
                        unitSelector: '.help-product-category li',
                        val: that.goodsCategoryId,
                        parentDom: that.goodsListDom
                    });
                    that.handleAppend({
                        unitSelector: '.pagination-page-num a',
                        val: that.goodsCategoryId,
                        parentDom: paginationNumDom
                    });
                    // 重新绑定分页点击事件
                    if (that.paginationA[0]) {
                        that.paginationA = _tool2.default.$_selectAll(that.displayDom, '.pagination-page-num a');
                    }
                    that.bindClick();
                }
                that.currentPage = 1;
                if (that.paginationA[0]) {
                    that.paginationA[0].click();
                }
            });
        });
        // 分页点击事件
        this.paginationA = _tool2.default.$_selectAll(this.displayDom, '.pagination-page-num a');
        this.bindClick();
        preBtn.addEventListener('click', function () {
            that.currentPage--;
            // 边界
            if (that.currentPage < 1) {
                that.currentPage = 1;
                return false;
            }
            var index = that.currentPage - 1;
            that.paginationA[index].click();
            that.handleAppend({
                unitSelector: '.help-product-category li',
                val: that.goodsCategoryId,
                parentDom: that.goodsListDom
            });
        });
        nextBtn.addEventListener('click', function () {
            that.currentPage++;
            // 边界
            if (that.currentPage > that.total) {
                that.currentPage = that.total;
                return false;
            }
            var index = that.currentPage - 1;
            that.paginationA[index].click();
            that.handleAppend({
                unitSelector: '.help-product-category li',
                val: that.goodsCategoryId,
                parentDom: that.goodsListDom
            });
        });
    };
    // 绑定分页点击事件
    HelpMain.prototype.bindClick = function () {
        var that = this;
        this.paginationA.forEach(function (item) {
            item.addEventListener('click', function () {
                var preBtnImg = _tool2.default.$_selectAll(that.displayDom, '.pagination-page-pre img');
                var nextBtnImg = _tool2.default.$_selectAll(that.displayDom, '.pagination-page-next img');
                that.paginationA.forEach(function (cItem) {
                    return cItem.classList.remove('active');
                });
                that.currentPage = Number(item.getAttribute('data-currentpage'));
                item.classList.add('active');
                that.handleAppend({
                    unitSelector: '.help-product-category li',
                    val: that.goodsCategoryId,
                    parentDom: that.goodsListDom
                });
                if (that.currentPage == 1 && that.total != 1) {
                    preBtnImg[0].classList.add('show');
                    preBtnImg[1].classList.remove('show');
                    nextBtnImg[0].classList.remove('show');
                    nextBtnImg[1].classList.add('show');
                } else if (that.currentPage == that.total && that.total != 1) {
                    preBtnImg[0].classList.remove('show');
                    preBtnImg[1].classList.add('show');
                    nextBtnImg[0].classList.add('show');
                    nextBtnImg[1].classList.remove('show');
                } else {
                    preBtnImg[0].classList.remove('show');
                    preBtnImg[1].classList.add('show');
                    nextBtnImg[0].classList.remove('show');
                    nextBtnImg[1].classList.add('show');
                }
            });
        });
    };
    // 插入父元素
    HelpMain.prototype.handleAppend = function (obj) {
        var parentDom = obj.parentDom;
        var unitDom = this.handleUnit(obj);
        parentDom.innerHTML = '';
        parentDom.insertAdjacentHTML('beforeend', unitDom);
    };
    // 组装dom单元
    HelpMain.prototype.handleUnit = function (obj) {
        var unitSelector = obj.unitSelector,
            val = obj.val;
        var appendStr = '';
        var pageSize = 12;
        switch (unitSelector) {
            case '.help-product-category li':
                if (val != 0) {
                    // 其他分类
                    for (var _i = 0, goodsCategory_1 = goodsCategory; _i < goodsCategory_1.length; _i++) {
                        var item = goodsCategory_1[_i];
                        if (item.id == val) {
                            var perPageList = JSON.parse(JSON.stringify(item.children));
                            perPageList = perPageList.slice(pageSize * (this.currentPage - 1), pageSize * this.currentPage); // 前端分页
                            for (var _a = 0, perPageList_1 = perPageList; _a < perPageList_1.length; _a++) {
                                var cItem = perPageList_1[_a];
                                appendStr += "<li>\n                    <a href=\"".concat(cItem.details_url, "/help.html\" target=\"_blank\">\n                      <img src=\"").concat(cItem.i_url, "\" alt=\"\">\n                      <h2>").concat(cItem.g_name, "</h2>\n                    </a>\n                  </li>");
                            }
                            break;
                        }
                    }
                } else {
                    // 全部
                    var perPageList = JSON.parse(JSON.stringify(goodsList));
                    perPageList = perPageList.slice(pageSize * (this.currentPage - 1), pageSize * this.currentPage); // 前端分页
                    for (var _b = 0, perPageList_2 = perPageList; _b < perPageList_2.length; _b++) {
                        var item = perPageList_2[_b];
                        appendStr += "<li>\n                    <a href=\"".concat(item.details_url, "/help.html\" target=\"_blank\">\n                      <img src=\"").concat(item.i_url, "\" alt=\"\">\n                      <h2>").concat(item.g_name, "</h2>\n                    </a>\n                  </li>");
                    }
                }
                break;
            case '.pagination-page-num a':
                var paginationBoxDom = _tool2.default.$_select(this.displayDom, '.pagination-box');
                if (val != 0) {
                    for (var _c = 0, goodsCategory_2 = goodsCategory; _c < goodsCategory_2.length; _c++) {
                        var item = goodsCategory_2[_c];
                        if (item.id == val) {
                            this.total = Math.ceil(item.children.length / pageSize); // 总页数
                            break;
                        }
                    }
                } else {
                    this.total = Math.ceil(goodsList.length / pageSize); // 总页数
                }
                if (this.total <= 1) {
                    paginationBoxDom.classList.add('pagination-box', 'hide');
                } else {
                    paginationBoxDom.classList.remove('hide');
                }
                for (var i = 0; i < this.total; i++) {
                    if (i == 0) {
                        appendStr += "<a data-currentpage=\"".concat(i + 1, "\" class=\"active\">").concat(i + 1, "</a>");
                    } else {
                        appendStr += "<a data-currentpage=\"".concat(i + 1, "\">").concat(i + 1, "</a>");
                    }
                }
                break;
        }
        return appendStr;
    };
    return HelpMain;
}();
exports.default = HelpMain;